import { Link } from "react-router-dom";

export default function BlogGridItem({ blog = {} }) {
  const { id, image, title, likes, createdAt, isSaved, tags } = blog;
  const coppiedTags = [...tags];
  if (coppiedTags.length > 3) coppiedTags.length = 3;
  return (
    <div className="lws-card">
      <Link to={`blogs/${id}`}>
        <img src={image} className="lws-card-image" alt="" />
      </Link>
      <div className="p-4">
        <div className="lws-card-header">
          <p className="lws-publishedDate">{createdAt}</p>
          <p className="lws-likeCount">
            <i className="fa-regular fa-thumbs-up"></i>
            {likes}
          </p>
        </div>
        <Link to={`blogs/${id}`} className="lws-postTitle">
          {" "}
          {title}{" "}
        </Link>
        <div className="lws-tags">
          <span>#{coppiedTags.join(", ")}</span>
          {/* <span>#python,</span> <span>#tech,</span> <span>#git</span> */}
        </div>
        {/* <!-- Show this element if post is saved --> */}
        <div className="flex gap-2 mt-4">
          {isSaved === true ? (
            <span className="lws-badge"> saved </span>
          ) : (
            <span className=""> Save </span>
          )}
        </div>
        {/* <!-- Show this element if post is saved Ends --> */}
      </div>
    </div>
  );
}
